import application_settings from '../applicationSettings';
import Event from './Event';

class GetPendingReviews extends Event {
    eventName = 'oms_getPendingReviews';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get order history
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.getPendingReviews;
        data.canUsePublicAuth = false;
        data.data = {
            with_order_product: data.with_order_product,
            start: data.start,
            limit: data.limit,
            order_currency: data.order_currency
        };

        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
    }
}

export default GetPendingReviews;